var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "draw 1",
    clipPath: "url(#clip0_217_2116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#000000ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2719 0.541377C15.7848 0.0425485 16.6047 -0.0918265 17.2523 0.210127C17.5742 0.347236 17.8152 0.607392 18.0566 0.851142C18.493 1.28786 18.9293 1.72419 19.366 2.16052C19.5262 2.32419 19.7027 2.4781 19.8156 2.68083C19.9156 2.84841 19.9648 3.03981 20.0008 3.23005V3.49216C19.9715 3.67536 19.9273 3.85895 19.8371 4.02263C19.7051 4.27888 19.4766 4.46247 19.2809 4.66677C18.7035 5.23435 18.1449 5.82224 17.5563 6.37653C16.2094 5.01638 14.8492 3.66872 13.498 2.31247C14.0895 1.72224 14.6773 1.12849 15.2719 0.541377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.14258 13.6711C5.5668 10.2328 9.00625 6.80935 12.4309 3.37146C13.7953 4.71873 15.1426 6.08396 16.5035 7.43474C13.0793 10.8734 9.63906 14.2965 6.21367 17.7336C5.8832 17.4269 5.57383 17.0972 5.25156 16.7816C4.21445 15.7453 3.18008 14.707 2.14258 13.6711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 19.4332C0.348438 17.8793 0.691406 16.3246 1.03906 14.7707C2.33086 16.0609 3.61992 17.3535 4.91133 18.6437C4.97578 18.705 5.0418 18.766 5.0875 18.8437C3.57773 19.2105 2.06797 19.5761 0.557422 19.9398C0.302734 20.0027 0.0433594 19.8078 0 19.5558V19.4332Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_2116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.351e49584b2325f970d8517f60d232dd.svg";
export { ForwardRef as ReactComponent };